import { useIntl } from 'react-intl';
import { Row, Col } from 'reactstrap';

import { Schema } from 'src/utils/form';
import Edit from 'src/componentes/edit/edit-dialog';
import Input from 'src/componentes/input';
import TipoRecursoLookup from 'src/lookups/TipoRecursoLookup';
import { capitalizeFirstLetter } from 'src/utils/string';

const schema = Schema.object({
  idIntegracao: Schema.string(),
  nome: Schema.string().required(),
});

const EditForm = ({ model }) => {
  const intl = useIntl();

  const modelIdIntegracao = model.getModel('idIntegracao');
  const modelNome = model.getModel('nome');
  const modelTipo = model.getModel('tipo');

  const disabled = model.getModel('permissions').value
    ? !model.getModel('permissions').value?.allowEdit
    : false;

  return (
    <>
      <Row>
        <Col md={3}>
          <Input
            maxLength={500}
            disabled={disabled}
            model={{
              label: intl.formatMessage({ id: 'idIntegracao' }),
              value: modelIdIntegracao.value,
              requestChange: modelIdIntegracao.requestChange,
              errors: modelIdIntegracao.errors,
            }}
          />
        </Col>

        <Col md={6}>
          <Input
            disabled={disabled}
            model={{
              label: intl.formatMessage({ id: 'nome' }),
              value: modelNome.value,
              requestChange: modelNome.requestChange,
              errors: modelNome.errors,
            }}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <TipoRecursoLookup
            model={{
              label: intl.formatMessage({ id: 'tipo' }),
              value: modelTipo.value,
              requestChange: modelTipo.requestChange,
              errors: modelTipo.errors,
            }}
            required
            disabled={disabled}
          />
        </Col>
      </Row>
    </>
  );
};

const EditView = (props) => {
  const intl = useIntl();

  return (
    <Edit
      url="/Recurso"
      title={capitalizeFirstLetter(intl.formatMessage({ id: 'recurso' }))}
      schema={schema}
      formComponent={EditForm}
      width="90%"
      maxWidth="80%"
      maxHeight="80%"
      intl={intl}
      {...props}
      showExport={false}
    />
  );
};

export default EditView;
